<template>
    <div>
    <v-layout wrap pa-2 style="background-color: white;">
        <v-flex xs12>table</v-flex>
        <v-flex xs12>
            <v-expansion-panels flat>
        <v-expansion-panel v-for="(item, index) in outerData" :key="index">
          <v-expansion-panel-header>
            {{ item.name }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Nested Column 1</th>
                    <th>Nested Column 2</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(nestedItem, nestedIndex) in item.nestedData" :key="nestedIndex">
                    <td>{{ nestedItem.nestedColumn1 }}</td>
                    <td>{{ nestedItem.nestedColumn2 }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
           
          </v-expansion-panel-content>
          <v-layout>
            <v-flex xs12 px-4>
                <v-divider ></v-divider>
            </v-flex>
        </v-layout>
        </v-expansion-panel>
      </v-expansion-panels>
        </v-flex>
    </v-layout>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        outerData: [
          {
            name: "Row 1",
            nestedData: [
              { nestedColumn1: "Nested Row 1 Column 1", nestedColumn2: "Nested Row 1 Column 2" },
              { nestedColumn1: "Nested Row 2 Column 1", nestedColumn2: "Nested Row 2 Column 2" },
            ],
          },
          {
            name: "Row 2",
            nestedData: [
              { nestedColumn1: "Nested Row 1 Column 1", nestedColumn2: "Nested Row 1 Column 2" },
              { nestedColumn1: "Nested Row 2 Column 1", nestedColumn2: "Nested Row 2 Column 2" },
            ],
          },
        ],
      };
    },
  };
  </script>
  